/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function JonathanGreenSingleGiftFaqModule(elem) {
        Behaviors.init(JonathanGreenSingleGiftFaqModule, this, arguments);
        var $thisElem = this.$elem;
    }
    Behaviors.inherit(JonathanGreenSingleGiftFaqModule, Behaviors.Behavior);
    JonathanGreenSingleGiftFaqModule.QUERY = "[data-JonathanGreenSingleGiftFaqModule]";
    JonathanGreenSingleGiftFaqModule.ELEMENTS = {
        loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(JonathanGreenSingleGiftFaqModule);
    module.JonathanGreenSingleGiftFaqModule = JonathanGreenSingleGiftFaqModule;
    return module;
}(window.jQuery, window.Behaviors));
